import { useState, useEffect, useContext } from "react";
import { API_URLS, BEARER_TOKENS } from "./config";
import { LanguageContext } from "../locale";
import axios from 'axios';
import { checkImageExists } from "./assetsService";

interface NavbarLabels {
  title: string;
  rulesSetTitle: string;
  faqTitle: string;
  myAnalyses: string;
  newAnalyse: string;
  logo: string;
  video_url: string;
  type_of_url: string;
  twinTool_title: string,
  twinTool_logo: string,
}

export function useNavBarLabelsService() {
  const { language } = useContext(LanguageContext);
  const [navbarLabels, setAppLabels] = useState<NavbarLabels | null>(null);
  const [loading, setLoading] = useState<Boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const domain = window.location.hostname;

  function checkUrlType(url: string) {
    try {
      const parsedUrl = new URL(url);
  
      const isYouTube = parsedUrl?.hostname?.includes('youtube.com') ||
                        parsedUrl?.hostname?.includes('youtu.be');
  
      const isBlob = parsedUrl?.protocol === 'blob:';
  
      if (isYouTube) return 'youtube';
      if (isBlob) return 'blob';
      return 'other';
    } catch (e) {
      return 'invalid';
    }
  }
  

  useEffect(() => {
    const fetchAppLabels = async () => {
      try {
        // const response = await axios.get(API_URLS.NAVBAR, {
        //   params: {
        //     locale: language,
        //   }
        // });   

        const response = await axios.get(API_URLS.APP_SETTINGS, {
          params: {
            locale: language,
            populate: "*",
            filters:{
                  hostname: {
                    $eq: domain,
                  },
              },
          }
        });

        // check response
        if (response.status != 200) {
          throw new Error("Failed to fetch Navbar data");
        }

        let static_title = "";
        let static_favicon = "";
        let static_logo = "";
        let twinTool_title = "";
        let twinTool_logo = "";

        if(window.location.host.includes("positiverepresentation")) {
          static_title = "Positive Representations";
          static_favicon = "/prai";
          static_logo = "/prai.svg";
          twinTool_title = "Antigreenwashing AI";
          twinTool_logo = "/agwai.svg";
        } else {
          static_title = "Antigreenwashing AI";
          static_favicon = "/agwai";
          static_logo = "/agwai.svg";
          twinTool_title = "Positive Representations AI";
          twinTool_logo = "/prai.svg";
        }

        const json = response.data;
        const cmsMediaBaseUrl = (API_URLS?.STRAPI_BASE_URL ?? window.location.origin);
        const favIconUrl = cmsMediaBaseUrl + json.data?.[0]?.favicon?.[0]?.url;
        const logoUrl = cmsMediaBaseUrl + json.data?.[0]?.logo?.[0]?.url;
        checkImageExists(favIconUrl, (exists) => {
          if (exists) {
            static_favicon = favIconUrl;
          }
        });
        checkImageExists(logoUrl, (exists) => {
          if (exists) {
            static_logo = logoUrl;
          }
        });
        document.title = json.data[0]?.title || static_title;
        const timestamp = Date.now();
        document.querySelector("link[rel='icon']")?.setAttribute("href", `${static_favicon}.ico?v=${timestamp}`);
        document.querySelector("link[rel='mask-icon']")?.setAttribute("href", `${static_favicon}.svg?v=${timestamp}`);
        document.querySelector("link[rel='apple-touch-icon']")?.setAttribute("href", `${static_favicon}.png?v=${timestamp}`);
        
        const labels = {
          title: json.data[0]?.title || static_title,
          rulesSetTitle: json.data[0]?.rules_set_title || "Cadres de Référence",
          faqTitle: json.data[0]?.faq_title || "Aide",
          myAnalyses: json.data[0]?.my_analyses || "Mes analyses",
          newAnalyse: json.data[0]?.new_analyse || "Nouvelle analyse",
          logo: static_logo,
          video_url: json.data[0]?.video_url,
          type_of_url: checkUrlType(json.data[0]?.video_url),
          twinTool_title: twinTool_title,
          twinTool_logo: twinTool_logo,
        };

        setAppLabels(labels);
      } catch (err) {
        setError((err as Error).message);
      } finally {
        setLoading(false);
      }
    };

    fetchAppLabels();
  }, [language]);

  return { navbarLabels, loading, error };
}
